import React from 'react';
import { PageHero } from '../components/PageUI';

const ObrigadoDemonstracaoPage = () => (
  <div>
    <PageHero
      eyebrow="Obrigado"
      title="Demonstração solicitada com sucesso."
      subtitle="Nosso time entrará em contato em breve."
      primaryCta={{ label: 'Ver casos de sucesso', href: '/casos-sucesso' }}
      secondaryCta={{ label: 'Voltar para Home', href: '/' }}
    />
  </div>
);

export default ObrigadoDemonstracaoPage;
